import $ from 'jquery'
$(document).ready(function () {

	function isMobile() {
		return window.innerWidth < 700
	}
})